import script from "./notice.vue?vue&type=script&lang=ts&setup=true"
export * from "./notice.vue?vue&type=script&lang=ts&setup=true"

import "./notice.vue?vue&type=style&index=0&id=ad3a4e26&lang=less"

const __exports__ = script;

export default __exports__